import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "../pages/navbar/Sidebar";

const PrivateRoute = () => {
  const token = useSelector((state: any) => state.metaData?.userInfo?.token);
  return token ? <><Sidebar /><Outlet /></> : <Navigate to="/signin" replace />;
};

export default PrivateRoute;
